import React, { useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button, ModalBody, Modal } from "reactstrap";
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import { Autocomplete } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';


const RSMAllocation = () => {
    const [open, setOpen] = useState(false)
    const [showNewRowFields, setShowNewRowFields] = useState(false);
    const [showList, setShowList] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(true);
    const [addMoreBtn, setAddMoreBtn] = useState(false)
    document.title = "Dashboard | Procurement Dashboard";
    const handleProductNameClick = (isOpen) => {
        setOpen(isOpen)
    };
    const handleallocateButtonClick = () => {
        setModalIsOpen(true);
    };
    const closeModal = () => {
        setModalIsOpen(false);
        setShowNewRowFields(false);
        setAddMoreBtn(false)
    };

    const handleButtonClick = () => {
        setIsEditMode(!isEditMode);
    };

    const columns = [
        {
            field: 'Sl_No', headerName: 'Sl.No', flex: .5,
            resizable: false,
            sortable: false,
        },
        {
            field: 'vendor_name',
            headerName: 'Vendor Name',
            sortable: false,
            resizable: false,
            //   cellClassName: 'product_name_wrap center-aligndata ',
            //   width: 160,
            flex: 1,
            // width: 160,

        },
        {
            field: 'sengment',
            headerName: 'Segment',
            headerClassName: 'table-header-background',
            // width: 160,
            resizable: false,
            sortable: false,
            flex: 1,
        },
        {
            field: 'category',
            headerName: 'Category',
            headerClassName: 'table-header-background',
            // width: 160,
            resizable: false,
            sortable: false,
            flex: 1,
        },
        {
            field: 'vertical',
            headerName: 'Vertical',
            headerClassName: 'table-header-background',
            // width: 160,
            resizable: false,
            sortable: false,
            flex: 1,
        },
        {
            field: 'Product_Name',
            headerName: 'Product Name',
            headerClassName: 'break-header',
            cellClassName: 'product_name_wrap',
            width: 160,
            // width: 250,
            resizable: false,
            sortable: false,
            flex: 1,
            renderCell: (params) => {
                const productName = params.value;
                return (
                    <div style={{ cursor: 'pointer' }} onClick={() => handleProductNameClick(true)}>
                        {productName}
                    </div>
                );
            },
        },
        {
            field: 'Approved_qty',
            headerName: 'Approved QTY',
            headerClassName: 'table-header-background',
            sortable: false,
            resizable: false,
            // width: 160,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
        },

        {
            field: 'action',
            headerName: 'Action',
            headerClassName: 'table-header-background',
            sortable: false,
            resizable: false,
            width: 160,
            renderCell: (params) => {
                return <div className="mt-1 mb-1">
                    <button onClick={handleallocateButtonClick} className="allocate_badge p-1 ps-3 pe-3">Allocate</button>
                </div>;
            },
        },
    ];

    const rows = [
        { id: 1, Sl_No: 1, vendor_name: 'Zhonghan Wantai', Product_Name: 'HOBS HB-MARICA', sengment: 'Big', category: "Chimney", vertical: 'Retail', Approved_by:'PO1234' },
        { id: 2, Sl_No: 2, vendor_name: 'Zhonghan Wantai', Product_Name: 'HOBS HB-MARICA',  sengment: 'Small', category: 'Hobs', vertical: 'Retail', Approved_by:'PO1234'},
    ];
    const handleAddNewRow = () => {
        setShowNewRowFields(false); 
        setAddMoreBtn(false)
    }
    const toggleNewRowFields = () => {
        setShowNewRowFields(!showNewRowFields);
        if (!showNewRowFields) {
            // fetchExecutiveOptions();
            setAddMoreBtn(true)
        }

    };
    const top100Films = [
        { label: 'The Shawshank Redemption', year: 1994 },
        { label: 'The Godfather', year: 1972 },
        { label: 'The Godfather: Part II', year: 1974 },
        { label: 'The Dark Knight', year: 2008 },
        { label: '12 Angry Men', year: 1957 },]
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* <BreadCrumb title="Sales Head Dashboard" pageTitle="Sales Head Dashboard" />
                    <div>
                        <h3>Dashboard</h3>
                    </div> */}
                    <div>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <div>
                                <h4 className="mb-0 requisition_text">RSM Allocation</h4>
                            </div>
                            {/* <div>
                                <Button variant="outlined" className="filter_button">View All</Button>
                            </div> */}
                        </div>

                        <Box sx={{ height: 400, width: '100%', marginBottom: '10px' }}>
                            <DataGrid
                                className="table_header_background"
                                headerClassName="custom-header-cell"
                                getRowHeight={() => 'auto'}
                                rows={rows}
                                columns={columns}
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 5,
                                        },
                                    },
                                }}
                                pageSizeOptions={[5]}
                                disableRowSelectionOnClick
                                disableColumnMenu
                                componentsProps={{
                                    cell: {
                                        disableClick: true,
                                    },
                                }}
                                sx={{
                                    '& .MuiDataGrid-cell': {
                                        '& .MuiDataGrid-cell--textOverflow': {
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                        },
                                    },
                                }}
                            />
                        </Box>
                    </div>
                </Container>
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Example Modal"
                className="rsm_allcation_modal"
            >
               <div className='d-flex justify-content-between me-2 mt-3'>
                    <h4 className='ms-3'>CHY-CURVY 60-RETAIL</h4>
                    <div  className='d-flex justify-content-end me-3 modal_close'>
                        <i class="ri-close-line" onClick={closeModal}></i>
                    </div>
                </div>
                <hr className='mb-2 mt-1 ms-3 me-3'></hr>
                <ModalBody className='pt-2'>
                    <div className="d-flex align-items-center gap-2">
                        <div>
                            <TextField
                                className="create_requisition_textfield"
                                // id={`quantity-${index}`}
                                label="RSM Name"
                                variant="outlined"
                                // value={row.quantity}
                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                sx={{ width: 235 }} // Increase size
                            />
                        </div>
                        <div className="d-flex align-items-center">
                            <div>
                            <TextField
                                type="number"
                                className="create_requisition_textfield"
                                // id={`allocated-quantity-${index}`}
                                label="Quantity"
                                variant="outlined"
                                // value={allocationQtyMap[index] || ''}
                                // onChange={(event) => handleAllocationQtyChange(index, event.target.value)}

                                sx={{ width: '140px' }}
                            />
                            </div>
                            <div className="ms-2">
                            {isEditMode ? (
                                        <div className="d-flex gap-2 align-items-center">
                                        <button onClick={handleButtonClick} className="approval_edit d-flex align-items-center">Edit</button>
                                        <button
                                        className="approval_edit"
                                        onClick={handleButtonClick}
                                    >
                                        Save
                                    </button>
                                    </div>
                                    ) : (
                                        <button onClick={handleButtonClick} className="approval_edit">Modified</button>
                                    )}
                                    </div>
                        </div>
                        <div className='d-flex align-items-center'><HighlightOffIcon color='error' // Apply custom color
                        />
                        </div>
                    </div>
                    <hr></hr>
                    {showNewRowFields && (
                            <>
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    <div>
                                    <Autocomplete
                                        disablePortal
                                        className="create_requisition_field"
                                        options={top100Films} // Pass executiveOptions array as options
                                        sx={{ width: 240 }}
                                        id='new-executive'
                                        // onChange={handleExecutiveChange}

                                        renderInput={(params) => <TextField {...params} label="RSM Name" />}
                                    />
                                    </div>
                                    <div style={{ width: '140px' }}>
                                        <TextField
                                                    type="number"
                                                    className="addrequisiton_field"
                                                    id={'new-quanyity'}
                                                    label="Quantity"
                                                    variant="outlined"
                                                    // value={quantity}
                                                    // onChange={handleQuantityChange}
                                                    sx={{ width: '140px' }}
                                                    // disabled={quantityDisabled}
                                        />

                                    </div>
                                    <div>

                                        <Button className="approval_edit" onClick={handleAddNewRow} variant="outlined" >Add</Button>
                                    </div>
                                </div>
                                <hr></hr>
                            </>
                        )}
                    <div className="mt-3">
                    <button className='add_more_button' onClick={toggleNewRowFields}disabled={addMoreBtn}>+ Add More</button>
                    </div>
                    <div className='d-flex align-items-center mt-4 justify-content-center'>
                        <button className="yes_button d-flex align-items-center">
                            Done
                        </button>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};

export default RSMAllocation;
